import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchBoxLite from '@homeaway/react-searchbox-lite';
import { FormattedMessage } from '../Intl';
import { messageKeys, getLabels } from './translations';
import { Experiment } from '../Experiment';

import './SearchBox.less';

class SearchBox extends Component {
  componentDidMount() {
    window.ha.userTiming.mark('primary.action.rendered');
  }

  onSubmit = ({ searchPath }) => {
    window.location.href = searchPath;
  }

  render() {
    const {
      locale,
      site,
      destination,
      checkIn,
      checkOut,
      guests,
      lbsId,
      domain,
      isMobile
    } = this.props;

    return (
      <FormattedMessage id={messageKeys}>
        {(...messages) => (
          <Experiment name="ptaHpNoSuggestionsDestination">
            {hideInlineSuggestion => (
              <SearchBoxLite
                brand={site === 'vrbo' ? 'vrbo' : 'homeaway'}
                stabTheme
                consolidatedSearchBox
                datePickerIcon
                guestPickerIcon
                expandedSearchBox
                showNextTooltip
                submitFromGuestPicker
                isStickyMobile={isMobile}
                labels={getLabels(...messages)}
                geoType={'point_of_interest'}
                onSubmit={this.onSubmit}
                typeaheadProps={{
                  baseUrl: 'https://www.homeaway.com',
                  environment: 'production',
                  site,
                  hideInlineSuggestion: !!hideInlineSuggestion
                }}
                {...{ domain, site, checkIn, checkOut, guests, lbsId, locale, destination }}
              />
            )}
          </Experiment>
        )}
      </FormattedMessage>
    );
  }
}

SearchBox.propTypes = {
  locale: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  guests: PropTypes.object,
  lbsId: PropTypes.string,
  destination: PropTypes.string,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  isMobile: PropTypes.bool.isRequired
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/universal/components/SearchBox/SearchBox.js